import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Input, Button, Row, Col, Select, notification } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../../admin/i18n/adminI18n';
import Toast from 'antd-mobile/lib/toast';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import './UpdatePopup.css';

const { Option } = Select;

@inject(
    'CmsLanguageStore',
    'popupStore'
)
@observer
class UpdatePopupModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            uploading: false
        }
    }

    componentDidMount() {
        this.props.CmsLanguageStore.getActives();
    }

    // ON CLICK

    createPopupOnClick = () => {
        const { t } = this.props;
        this.props.popupStore.createPopup().then(resp => {
            if (!resp.isError) {
                notification['success']({
                    message: t('Success'),
                    description: t('Popup is successfully created.'),
                    duration: 1
                });
                this.props.popupStore.initPopup();
            } else {
                notification['error']({
                    message: t('Failed'),
                    description: resp.error,
                    duration: 5
                });
                this.props.popupStore.setupdateLoading(false);
            }
        });
    }

    updatePopupOnClick = () => {
        const { t } = this.props;
        this.props.popupStore.updatePopup().then(resp => {
            if (!resp.isError) {
                notification['success']({
                    message: t('Success'),
                    description: t('Popup is successfully updated.'),
                    duration: 1
                });
                this.props.popupStore.initPopup();
            } else {
                notification['error']({
                    message: t('Failed'),
                    description: resp.error,
                    duration: 5
                });
                this.props.popupStore.setupdateLoading(false);
            }
        });
    }

    cancelPopupOnClick = () => {
        this.props.popupStore.setShowUpdatePopupModal(false);
    }

    isLanguageIdActive = (languageId) => {
        const { activeLanguages } = this.props.CmsLanguageStore;

        if (activeLanguages) {
            const language = activeLanguages.find(fi => fi.id === languageId);
            if (language) {
                return true;
            }
        }

        return false;
    }

    render() {
        const { activeLanguages } = this.props.CmsLanguageStore;

        const {
            popup,
            moduleNames,
            updateLoading
        } = this.props.popupStore;

        let hasError = true;

        if (popup) {
            if (popup.popupLanguages) {
                const popupLanguage = popup.popupLanguages.find(fi => fi.languageId === 1);

                if (popupLanguage) {
                    hasError = popup.moduleName === '' || popupLanguage.title === '' || popupLanguage.description === '';
                }
            }
        }

        const { t } = this.props;

        if (updateLoading) {
            Toast.loading(t('Saving...'), 100, null, true);
        } else {
            Toast.hide();
        }

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            {
                                popup
                                    ?
                                    <>
                                        <Form layout='vertical'>
                                            <Row>
                                                <Col span={6} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20'>{t('Module Name')}</Col>
                                                <Col span={18} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20'>
                                                    <Select
                                                        value={popup.moduleName}
                                                        onChange={(value) => this.props.popupStore.setmoduleName(value)}
                                                        className='stm-width-266'>
                                                        {
                                                            moduleNames.map(moduleName => {
                                                                return (<Option key={moduleName.value} value={moduleName.value}>{moduleName.label}</Option>)
                                                            })
                                                        }
                                                    </Select>
                                                    <>
                                                        {
                                                            popup.moduleName === ''
                                                                ?
                                                                <div className='stm-color-error stm-padding-top-4'>* {t('Required')}</div>
                                                                :
                                                                null
                                                        }
                                                    </>
                                                </Col>
                                            </Row>

                                            {/* Title */}
                                            <Row>
                                                <Col span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20'>{t('Title')}</Col>
                                                <>
                                                    {
                                                        popup.popupLanguages
                                                            ?
                                                            <>
                                                                <Row>
                                                                    {
                                                                        activeLanguages.map(lang => {
                                                                            return (
                                                                                <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20'>
                                                                                    <Row>
                                                                                        <Col span={6} className='stm-padding-left-16'>{lang.originalName} {lang.id === 1 ? '*' : null}</Col>
                                                                                        <Col span={18} className=''>
                                                                                            <Input
                                                                                                value={popup.popupLanguages.find(fi => fi.languageId === lang.id).title}
                                                                                                onChange={(e) => this.props.popupStore.settitle(lang.id, e.target.value)}
                                                                                                className='stm-width-100-percent' />
                                                                                            <>
                                                                                                {
                                                                                                    lang.id === 1 && popup.popupLanguages.find(fi => fi.languageId === lang.id).title === ''
                                                                                                        ?
                                                                                                        <div className='stm-color-error stm-padding-top-4'>* {t('Required')}</div>
                                                                                                        :
                                                                                                        null
                                                                                                }
                                                                                            </>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </Col>
                                                                            )
                                                                        })
                                                                    }
                                                                </Row>
                                                            </>
                                                            :
                                                            null
                                                    }
                                                </>
                                            </Row>

                                            {/* Description */}
                                            <Row>
                                                <Col span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20'>{t('Description')}</Col>
                                                <>
                                                    {
                                                        popup.popupLanguages
                                                            ?
                                                            <>
                                                                <Row>
                                                                    {
                                                                        activeLanguages.map(lang => {
                                                                            return (
                                                                                <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20'>
                                                                                    <Row>
                                                                                        <Col span={6} className='stm-padding-left-16'>{lang.originalName} {lang.id === 1 ? '*' : null}</Col>
                                                                                        <Col span={18} className=''>
                                                                                            <>
                                                                                                <CKEditor
                                                                                                    editor={ClassicEditor}
                                                                                                    data={popup.popupLanguages.find(fi => fi.languageId === lang.id).description}
                                                                                                    onChange={(event, editor) => {
                                                                                                        const data = editor.getData();
                                                                                                        this.props.popupStore.setdescription(lang.id, data)
                                                                                                    }}
                                                                                                />
                                                                                                {
                                                                                                    lang.id === 1 && popup.popupLanguages.find(fi => fi.languageId === lang.id).description === ''
                                                                                                        ?
                                                                                                        <div className='stm-color-error stm-padding-top-4'>* {t('Required')}</div>
                                                                                                        :
                                                                                                        null
                                                                                                }
                                                                                            </>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </Col>
                                                                            )
                                                                        })
                                                                    }
                                                                </Row>
                                                            </>
                                                            :
                                                            null
                                                    }
                                                </>
                                            </Row>

                                            <Form.Item>
                                                {
                                                    popup.id === 0
                                                        ?
                                                        <Button onClick={this.createPopupOnClick} style={{ marginRight: 10 }} type='primary' disabled={hasError}>{t('Create')}</Button>
                                                        :
                                                        <Button onClick={this.updatePopupOnClick} style={{ marginRight: 10 }} type='primary' disabled={hasError}>{t('Update')}</Button>

                                                }

                                                <Button onClick={this.cancelPopupOnClick}>{t('Cancel')}</Button>
                                            </Form.Item>
                                        </Form>
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(UpdatePopupModal);
